import React from 'react';
import { useTranslation } from 'react-i18next';
import { SUPPORT_EMAIL } from '../constants/support';
import { FileWarning, X, MessageCircle, Mail } from 'lucide-react';
import './UntranslatableModal.css';

const TELEGRAM_LINK = 'https://t.me/mrbuslov';

// Shown when the upload completeness guard refuses a document because it hides
// text our translator can't reach yet (headers/footers/footnotes/text boxes).
// Replaces a raw browser alert() with a real hand-off to a human channel.
function UntranslatableModal({ isVisible, fileName, onClose }) {
  const { t } = useTranslation('chat');

  if (!isVisible) return null;

  const mailtoHref = `mailto:${SUPPORT_EMAIL}?subject=${encodeURIComponent(
    t('untranslatable.emailSubject', { file: fileName || '' })
  )}`;

  return (
    <div className="untranslatable-overlay" onClick={onClose}>
      <div className="untranslatable-modal" onClick={(e) => e.stopPropagation()}>
        <button className="untranslatable-close" onClick={onClose}>
          <X size={20} />
        </button>

        <div className="untranslatable-icon">
          <FileWarning size={48} />
        </div>

        <h2 className="untranslatable-title">{t('untranslatable.title')}</h2>
        <p className="untranslatable-message">{t('untranslatable.message')}</p>

        <a
          href={TELEGRAM_LINK}
          target="_blank"
          rel="noopener noreferrer"
          className="untranslatable-button"
        >
          <MessageCircle size={20} />
          {t('untranslatable.telegram')}
        </a>

        <a href={mailtoHref} className="untranslatable-email">
          <Mail size={16} />
          {t('untranslatable.email', { email: SUPPORT_EMAIL })}
        </a>

        <button className="untranslatable-dismiss" onClick={onClose}>
          {t('untranslatable.dismiss')}
        </button>
      </div>
    </div>
  );
}

export default UntranslatableModal;
